/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: 0gf8lKLu2jNB

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { RawNull } from "@myevaluations/myevals-plasmic-utils/dist/code-components/RawNull/RawNull"; // plasmic-import: P90l9-wwCsyV/codeComponent
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicInfoSection.module.css"; // plasmic-import: 0gf8lKLu2jNB/css

createPlasmicElementProxy;

export type PlasmicInfoSection__VariantMembers = {};
export type PlasmicInfoSection__VariantsArgs = {};
type VariantPropType = keyof PlasmicInfoSection__VariantsArgs;
export const PlasmicInfoSection__VariantProps = new Array<VariantPropType>();

export type PlasmicInfoSection__ArgsType = {
  heading?: string;
  content?: React.ReactNode;
};
type ArgPropType = keyof PlasmicInfoSection__ArgsType;
export const PlasmicInfoSection__ArgProps = new Array<ArgPropType>(
  "heading",
  "content"
);

export type PlasmicInfoSection__OverridesType = {
  section?: Flex__<"div">;
  sectionHeading?: Flex__<"h2">;
};

export interface DefaultInfoSectionProps {
  heading?: string;
  content?: React.ReactNode;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicInfoSection__RenderFunc(props: {
  variants: PlasmicInfoSection__VariantsArgs;
  args: PlasmicInfoSection__ArgsType;
  overrides: PlasmicInfoSection__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {
          heading: "Information We Collect"
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"section"}
      data-plasmic-override={overrides.section}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_bvRZj1oZhhFBeMnkX2LkQu",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.section
      )}
    >
      <h2
        data-plasmic-name={"sectionHeading"}
        data-plasmic-override={overrides.sectionHeading}
        className={classNames(
          "all",
          "h2",
          "h2__bvRZj",
          "__wab_text",
          sty.sectionHeading
        )}
      >
        <React.Fragment>{$props.heading}</React.Fragment>
      </h2>
      {renderPlasmicSlot({
        defaultContents: <RawNull />,

        value: args.content
      })}
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  section: ["section", "sectionHeading"],
  sectionHeading: ["sectionHeading"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  section: "div";
  sectionHeading: "h2";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicInfoSection__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicInfoSection__VariantsArgs;
    args?: PlasmicInfoSection__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicInfoSection__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicInfoSection__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicInfoSection__ArgProps,
          internalVariantPropNames: PlasmicInfoSection__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicInfoSection__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "section") {
    func.displayName = "PlasmicInfoSection";
  } else {
    func.displayName = `PlasmicInfoSection.${nodeName}`;
  }
  return func;
}

export const PlasmicInfoSection = Object.assign(
  // Top-level PlasmicInfoSection renders the root element
  makeNodeComponent("section"),
  {
    // Helper components rendering sub-elements
    sectionHeading: makeNodeComponent("sectionHeading"),

    // Metadata about props expected for PlasmicInfoSection
    internalVariantProps: PlasmicInfoSection__VariantProps,
    internalArgProps: PlasmicInfoSection__ArgProps
  }
);

export default PlasmicInfoSection;
/* prettier-ignore-end */
